import React, { useEffect, useLayoutEffect, Suspense, useState } from 'react';
import { RouteComponentProps, navigate } from '@reach/router';
import { useDispatch } from 'react-redux';
import env from '@/env';
import { resetActions } from '@/redux/actions/reset';
import { getSubdomain, getWebAppInfo, renderRecaptchaToken, resetRecaptcha } from '@/utils';
import Navbar from '@/containers/Navbar/Navbar';
import Footer from '@/containers/Footer/Footer';
import HelmetHead from '@/components/HelmetHead/HelmetHead';
import LoadingFullPage from '@/components/LoadingFullPage/LoadingFullPage';
import { authHelpers } from '@/services/auth';
import './OpenDirectoryLayout.scss';

interface OpenDirectoryProps extends RouteComponentProps {
  children: React.ReactNode;
  params?: { [key: string]: string };
}

const OpenDirectoryLayout: React.FC<OpenDirectoryProps> = ({ children, params }) => {
  const dispatch = useDispatch();
  const subdomain = getSubdomain();
  const webApp = getWebAppInfo(env.siteId);
  const needVerification = authHelpers.getNeedVerification();
  const sessionVerification = authHelpers.getSessionVerification();
  const sessionNeedVerification = sessionVerification && atob(sessionVerification) === 'true';
  const [renderLargeShiftLayout, setRenderLargeShiftLayout] = useState<boolean>(false);
  const needVerify =
    needVerification &&
    atob(needVerification) === 'true' &&
    sessionVerification &&
    atob(sessionVerification) === 'true';

  const handleLargeShiftLayout = (): void => {
    if (!renderLargeShiftLayout) {
      setRenderLargeShiftLayout(true);
    }
  };

  useLayoutEffect(() => {
    subdomain && subdomain !== 'www' && navigate(`https://www.${webApp.domain}/view/${subdomain}`);
  }, [subdomain, dispatch, webApp.domain]);

  useEffect(() => {
    return () => {
      dispatch(resetActions.reset('FETCH_ENTITY_DASHBOARD'));
    };
  }, [dispatch]);

  useEffect(() => {
    // First Access
    if (sessionVerification === undefined) {
      authHelpers.setSessionVerification();
    }
  }, [sessionVerification]);

  useEffect(() => {
    needVerify && resetRecaptcha();
    // eslint-disable-next-line
  }, [needVerification, sessionNeedVerification]);

  useEffect(() => {
    renderRecaptchaToken();
  }, []);

  return (
    <>
      <div id="Captcha" className={`${needVerify ? 'show' : 'hidden'}`} />
      <div
        id="OpenDirectoryLayout"
        className={`OpenDirectoryLayout ${needVerify ? 'blur' : ''}`}
        onMouseMove={handleLargeShiftLayout}
        onScroll={handleLargeShiftLayout}
      >
        <HelmetHead
          renderLargeShiftLayout={renderLargeShiftLayout}
          title={webApp.siteName}
          description={webApp.siteName}
        />
        <div className="OpenDirectoryLayout-navbar">
          {/* {renderLargeShiftLayout ? ( */}
          <Navbar params={params} renderLargeShiftLayout={renderLargeShiftLayout} />
          {/* ) : (
            <div className="OpenDirectoryLayout-fakeNavbar">
              <h1>
                Open Banking <br /> Directory
              </h1>
            </div>
          )} */}
        </div>
        <div className="OpenDirectoryLayout-body">
          <Suspense fallback={<LoadingFullPage />}>
            {children}
            {renderLargeShiftLayout && <Footer params={params} />}
          </Suspense>
        </div>
      </div>
    </>
  );
};

export default OpenDirectoryLayout;
